import React, { useState } from "react";
import { Box, Button, Input, VStack, Heading, Text } from "@chakra-ui/react";

const AGENT_USERNAME = "agent";
const AGENT_PASSWORD = "chang2026";

export default function AgentLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === AGENT_USERNAME && password === AGENT_PASSWORD) {
      setError("");
      onLogin();
    } else {
      setError("Invalid credentials");
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="transparent">
      <Box maxW="400px" w="100%" borderWidth={1} borderRadius="lg" boxShadow="md" bg="white">
        <Heading size="md" mb={4} textAlign="center">Agent Login</Heading>
        <form onSubmit={handleSubmit}>
          <VStack spacing={4} align="stretch">
            <Input
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <Text color="red.500">{error}</Text>}
            <Button type="submit" colorScheme="green">Login</Button>
          </VStack>
        </form>
      </Box>
    </Box>
  );
}

